export function isSubdomain(subdomain: string): boolean {
	const nonSubdomains = /http(s:|:)\/\/((app\.|www\.|app\.feature\d+\.)(seesonar|develop-seesonar|staging-seesonar)\.com|localhost:[0-9]+)/u;

	if (nonSubdomains.test(subdomain)) {
		return false;
	}

	return true;
}
